// Halo radial que sigue al cursor (spec §9.3/§15.4). Solo tarjetas marcadas
// con data-cursor-glow; nunca formularios, FAQ ni legales.
export function initCursorGlow() {
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const precisePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
	if (reducedMotion || !precisePointer) return;

	document.querySelectorAll("[data-cursor-glow]").forEach((card) => {
		// El mega menú trae su propio halo (más tenue) en su hoja de estilos.
		if (!card.classList.contains("psyque-mega__col")) {
			card.classList.add("psyque-card--cursor-glow");
		}
		let frame = null;

		card.addEventListener("pointermove", (event) => {
			if (frame) return;
			frame = window.requestAnimationFrame(() => {
				const rect = card.getBoundingClientRect();
				card.style.setProperty("--cursor-x", `${event.clientX - rect.left}px`);
				card.style.setProperty("--cursor-y", `${event.clientY - rect.top}px`);
				frame = null;
			});
		});
	});
}
